module.exports = __webpack_public_path__ + "static/media/infosys_logo.19be318b.png";